<template>
  <img
    v-if="pixel"
    v-show="false"
    :src="`https://biscotti.yektanet.com/pixel?id=atiyacrowd&window_id=${$cookies.get(
      'window_id'
    )}`"
  />
  <Loading v-if="loading"></Loading>
  <RouterView
    :authenticated="authenticated"
    :time="time"
    :_reminders_="reminders"
    :status="status"
    @onloading="(status) => (loading = status)"
  />
  <notifications position="top left" :duration="6000" :pauseOnHover="true" />
  <vue3-confirm-dialog />
</template>

<script>
/* eslint-disable */
import RouterView from "vue-router";
import Loading from "./components/Loading.vue";

export default {
  name: "App",
  inject: ["base"],
  components: {
    Loading,
    RouterView,
  },
  mounted() {
    if (window.screen.width > 430 || !this.path.includes("dashboard"))
      window.addEventListener("raychat_ready", function (ets) {
        window.Raychat.showWidget();
      });

    if (this.inspect) {
      document.addEventListener("contextmenu", (e) => e.preventDefault());
      document.onkeydown = (e) => {
        if (e.key === 123) e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "I") e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "C") e.preventDefault();
        if (e.ctrlKey && e.shiftKey && e.key === "J") e.preventDefault();
        if (e.ctrlKey && e.key === "U") e.preventDefault();
      };
    }
  },
  created() {
    localStorage.removeItem("active_folder");
    this.base.API().post(
      `Analysis/Session/Collect`,
      {
        data: {
          window_id: this.$cookies.get("window_id") || null,
        },
      },
      (response) => {
        if (this.base.Util().success(response) && response.data.data)
          this.$cookies.set(
            "window_id",
            response.data.data,
            "1Y",
            "/",
            ".atiyehiraniancf.com"
          );
        setTimeout(() => (this.pixel = true), 1000);
      },
      (error) => {}
    );

    this.init();
  },
  data() {
    return {
      identifier: "",
      authenticated: false,
      socket: null,
      time: 0,
      credits: 0,
      reminders: [],
      status: 0,
      inspect: false,
      path: window.location.pathname.toLowerCase(),
      routes: ["/dashboard"],
      loading: false,
      identify: false,
      pixel: false,
    };
  },
  watch: {
    $route(from, to) {
      this.path = window.location.pathname.toLowerCase();
    },
  },
  methods: {
    init() {
      this.authenticate(true);

      setInterval(() => this.authenticate(), 1000);

      this.base.Security().identify(this.routes);
    },
    shared() {
      if (this.socket && this.socket.initialized) return;
      if (!this.socket) {
        this.socket = new SharedWorker("/websocket-worker.js?v=6.0.0");
        this.socket.initialized = true;

        this.socket.port.onmessage = (event) => {
          const { type, data } = event.data;

          switch (type) {
            case "connected":
              setTimeout(() => {
                this.time = Number(localStorage.getItem("time")) || 0;
                this.credits = String(
                  Number(this.$cookies.get("balance") || 0) -
                    Number(this.$cookies.get("inprocess") || 0)
                ).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                this.status = localStorage.getItem("status") || "-1";
              }, 1000);
              break;

            case "message":
              let response = data;
              if (response.target) {
                switch (response.target) {
                  case "status":
                    this.status =
                      response.status === "under_maintenance" ? "2" : "1";
                    localStorage.setItem("status", this.status);
                    break;
                  case "span":
                    this.time = Number(response.data);
                    localStorage.setItem("time", this.time);
                    break;
                  case "reminders":
                    this.reminders = response.data;
                    break;

                  default:
                    break;
                }

                // if (response.message === "logout") {
                //   try {
                //     this.socket?.close();
                //   } catch (e) {}
                //   this.base.Security().logout();
                // }

                // if (response.categories && response.menus) {
                //   this.modules = {
                //     categories: response.categories,
                //     menus: response.menus,
                //     options: response.options,
                //   };
                //   localStorage.setItem(
                //     "modules",
                //     JSON.stringify([this.modules])
                //   );
                // }
              }
              break;

            case "reconnecting" || "disconnected":
              this.status = "0";
              localStorage.setItem("status", this.status);
              break;
          }
        };
        this.socket.port.start();
      }

      if (!this.socket.initializedOnce) {
        this.socket.port.postMessage({
          type: "init",
          cookies: { identifier: this.identifier },
        });
        this.socket.initializedOnce = true;
      }
    },
    routing() {
      if (
        !this.authenticated &&
        this.base.Util().validate(
          this.routes.filter((path) => {
            return window.location.pathname.toLowerCase().includes(path);
          })
        )
      )
        window.location.href = `/Authentication‍‍‍?return=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`;
      else if (
        this.authenticated &&
        (this.path === "/" ||
          this.path === "/admin" ||
          this.path === "/authentication" ||
          this.path === "/register")
      ) {
        window.location.href = "/Dashboard";
      }
    },
    authenticate(init) {
      const newIdentifier = this.$cookies.get("identifier");
      if (this.identifier === newIdentifier && !init) return;
      this.identifier = newIdentifier;
      this.authenticated = this.base.Util().validate(this.identifier);

      this.routing();
      this.base.Security().identify(this.routes);

      if (init) this.shared();
    },
  },
};
</script>

<style src="../src/assets/css/main.css" />
<style lang="less" src="../src/assets/css/main.less" />
<style src="vue3-carousel-3d/dist/index.css"></style>
<style src="../src/assets/css/views/shared.css" />
<style src="../node_modules/vue3-confirm-dialog/dist/style.css" />
